"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBrowser = isBrowser;
/**
 * Проверка находимся в браузере или нет.
 * @return Если в браузере true, если нет false.
 */
function isBrowser() {
    return typeof window !== 'undefined';
}
//# sourceMappingURL=is-browser.js.map